'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var iconfont_icon = require('./icon.js');
require('../_chunks/dep-2133149b.js');
require('vue');
require('./props/props.js');
require('../utils/use-size-props.js');
require('../utils/use-common-classname.js');
require('../utils/config-context.js');
require('../utils/check-url-and-load.js');

var IconFont = iconfont_icon.IconFont;

exports.IconFont = IconFont;
exports["default"] = IconFont;
//# sourceMappingURL=index.js.map
